import { render, staticRenderFns } from "./ClientContractForm.vue?vue&type=template&id=60cbc7de&scoped=true"
import script from "./ClientContractForm.vue?vue&type=script&lang=ts"
export * from "./ClientContractForm.vue?vue&type=script&lang=ts"
import style0 from "./ClientContractForm.vue?vue&type=style&index=0&id=60cbc7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cbc7de",
  null
  
)

export default component.exports